import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  sectionCard: {
    backgroundColor: theme.palette.grey[100],
    borderRadius: 12,
    padding: theme.spacing(2.5),
  },
  sectionTitle: {
    fontWeight: 700,
    marginBottom: theme.spacing(0.25),
  },
  enumChip: {
    backgroundColor: theme.palette.primary.hover,
    color: theme.palette.common.white,
    fontWeight: 700,
    height: 28,
  },
  alert: {
    borderRadius: 12,
    padding: theme.spacing(1.5, 2),
    marginTop: theme.spacing(1.5),
  },
  alertHeader: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1),
    marginBottom: theme.spacing(0.5),
  },
  alertTitle: {
    fontWeight: 700,
    letterSpacing: 0.5,
  },
  alertIcon: {
    flexShrink: 0,
  },
  alertLow: {
    backgroundColor: theme.palette.statusLabel.success.secondary,
    '& $alertTitle, & $alertIcon': {
      color: theme.palette.statusLabel.success.primary,
    },
  },
  alertMedium: {
    backgroundColor: theme.palette.statusLabel.warning.secondary,
    '& $alertTitle, & $alertIcon': {
      color: theme.palette.statusLabel.warning.primary,
    },
  },
  alertHigh: {
    backgroundColor: theme.palette.statusLabel.error.secondary,
    '& $alertTitle, & $alertIcon': {
      color: theme.palette.statusLabel.error.primary,
    },
  },
  toolIcon: {
    width: 24,
    height: 24,
    objectFit: 'contain',
  },
  divider: {
    margin: theme.spacing(1.5, 0),
    borderColor: theme.palette.divider,
  },
}))

export default useStyles
